export default __webpack_public_path__ + "static/media/9.f4e4afa5.png";